module.exports = __webpack_public_path__ + "static/media/og-image.f2d17f8b.jpg";